import React, { useState, useEffect } from 'react';
import { Button, FormControl, TextField } from "@material-ui/core";
import '../../../styles/banner.scss';
import config from '../../config/config';
import GoogleMaps from '../../common/GoogleMap/GoogleMaps';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Link } from "react-scroll";
import Modalpopup from '../../pages/Modalpopup/Modalpopup';
import CustomDrawer from '../../common/CustomDrawer/CustomDrawer';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import Modalpopupcalquemarket from '../../landing/Modalpopups/Modalpopupcalquemarket';
import { useFormik } from 'formik';
import { useGAEventsTracker } from '../../../util/gtag';
import Grid from '@material-ui/core/Grid';
import ApplicationFunnel from '../../common/ApplicationFunnelWidget/ApplicationFunnel';
// import Chatbot from '../../common/chatbot/Chatbot';

export default function Banner(props) {
    const GAEventTracker = useGAEventsTracker(window.location.pathname)
    const GAEventTrackerGetStarted = useGAEventsTracker(window.location.pathname + "/Get Started");
    const GAEventTrackerContactUs = useGAEventsTracker(window.location.pathname + "/Contact Us");
    const [openSubmit, setOpenSubmit] = React.useState(false);
    const [openCalque, setOpenCalque] = useState(false);
    const [detail, setDetail] = React.useState('');
    const [validateUserInfo, setValidateUserInfo] = useState(false)
    const [severity_type, setSeverityType] = React.useState('');
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [errorsOut, seterrorsOut] = useState()
    const [openFailure, setOpenFailure] = useState(false)
    const [openSuccess, setOpenSuccess] = useState(false)
    const [address, setAddress] = useState("");
    const [itemstype, setItemstype] = useState([]);
    const [gmapErr, setGmapErr] = useState(false)

    useEffect(()=>{
        if((props?.partner?.url_path === "c2")){
          const h2Tags = document.querySelectorAll('h2');
          const h3Tags = document.querySelectorAll('h3');
          const h4Tags = document.querySelectorAll('h4');
          const h6Tags = document.querySelectorAll('h6');
          const pTags = document.querySelectorAll('p');
          const liTags = document.querySelectorAll('li');
          const spanTags = document.querySelectorAll('span');
          const a = document.querySelectorAll('a');
            h2Tags.forEach(h2 => {
              h2.classList.add('ftpolar-semibold');
            });
            h3Tags.forEach(h3 => {
              h3.classList.add('ftpolar-light');
            });
            h4Tags.forEach(h4 => {
              h4.classList.add('ftpolar-semibold');
            });
            h6Tags.forEach(h6 => {
              h6.classList.add('ftpolar-semibold');
            });
            pTags.forEach(p => {
              p.classList.add('ftpolar-light');
            });
            liTags.forEach(li => {
              li.classList.add('ftpolar-light');
            });
            spanTags.forEach(span => {
              span.classList.add('ftpolar-light');
            });
            a.forEach(a => {
              a.classList.add('ftpolar-light');
            });
        }
      },[props?.partner?.url_path])

    const handleClose1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    const vertical = 'top';
    const horizontal = 'center';
    const handleClickOpen2 = () => {
        setOpenSubmit(!openSubmit);
    };
    const handleZipCode = () => {
        // props.setValidateControl(true)
        // props.setDisplayError(true)
        // let postData = {
        //     "zip_code": props.values.property_address ? props.values.property_address.zip_code : null
        // }
        // let authorise = process.env.REACT_APP_API_KEY
        // fetch(`${config.baseUrlCP}validate-zipcode/`,
        //     {
        //         method: 'POST',
        //         headers: {
        //             'Accept': 'application/json',
        //             'Authorization': `${authorise}`,
        //             'Content-Type': 'application/json',
        //             'Accept-Encoding': 'gzip, deflate',
        //         },
        //         body: JSON.stringify(postData),
        //     })
        //     .then(async response => {
        //         const results = await response.json()
        //         if (response.status === 201 || response.status === 200) {
        //             props.GAtimer()
        //             props.GAtimerFinish()
        //             if (results.is_operating_area === false) {
        //                 setOpenCalque(true)
        //                 props && props.setErrDisplay(false)
        //             } else {
        //                 setOpenCalque(false)
        //                 props.drawerHandleOpen();
        //                 props.handleReset();
        //                 props && props.setErrDisplay(false)
        //                 // Get the current URL
        //                 const currentUrl = window.location.pathname;
        //                 // Check if the URL ends with a slash, then append '/questionnaire'
        //                 const newUrl = currentUrl.endsWith('/') ? `${currentUrl}questionnaire/` : `${currentUrl}/questionnaire/`;
        //                 // Use pushState to change the URL without reloading the page
        //                 window.history.pushState(null, '', newUrl);
        //             }
        //             if (Object.keys(props.errors).length !== 0 && props.errors.property_type == undefined && props.errors.street_address == undefined) {
        //                 GAEventTracker("UserEnteredQuestionnaire", 1)
        //             }
        //         }
        //         else {
        //             setOpenCalque(false)
        //             props && props.setErrDisplay(false)
        //             setGmapErr(results.zip_code[0])
        //         }
        //     })
        //     .catch((error) => {
        //     })
// Get the current URL
const currentUrl = window.location.pathname;
// Check if the URL ends with a slash, then append '/questionnaire'
const newUrl = currentUrl.endsWith('/') ? `${currentUrl}questionnaire/` : `${currentUrl}/questionnaire/`;
// Use pushState to change the URL without reloading the page
window.history.pushState(null, '', newUrl);
    }
    const handlePopupSubmit = (event) => {
        setValidateUserInfo(true)
        if (!event.detail || event.detail == 1) { return true; }
        else { event.preventDefault(); }
    }
    const handleClickOpener = () => {
        setOpenCalque(!openCalque)
    };
    const onSubmit = values => {
        var postUserQue = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            "location": props.values && props.values.property_address.street_address,
            partner_id: props?.partner?.partner_id ? props.partner.partner_id : null,
        }
        let authorise = process.env.REACT_APP_API_KEY
        fetch(`${config.baseUrlCP}email-for-validate-zipcode/`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `${authorise}`,
                    'Content-Type': 'application/json',
                    'Accept-Encoding': 'gzip, deflate',
                },
                body: JSON.stringify(postUserQue),
            })
            .then(async response => {
                const results = await response.json()
                if (response.status === 201 || response.status === 200) {
                    setOpenSnackbar(true)
                    setDetail(results.message);
                    setSeverityType("success");
                    setOpenSuccess(!openSuccess);
                    setOpenSubmit(false)
                    setValidateUserInfo(false)
                    formik.setFieldValue('first_name', '')
                    formik.setFieldValue('last_name', '')
                    formik.setFieldValue('email', '')
                    formik.setFieldValue('location', '')
                    setOpenCalque(false)
                }
                else {
                    if (results.detail) {
                        setOpenSnackbar(true)
                        setDetail(results.message)
                        setSeverityType("error");
                        setOpenFailure(!openFailure);
                        setOpenSubmit(false)
                        formik.setFieldValue('first_name', '')
                        formik.setFieldValue('last_name', '')
                        formik.setFieldValue('email', '')
                        formik.setFieldValue('user_question', '')
                        await sleep(2000);
                    } else {
                        setSeverityType("error");
                    }
                }
            })
            .catch((error) => {
                setDetail("Something Went Wrong!")
                setSeverityType("error");
                setOpenSnackbar(true)
                setOpenSubmit(false)
            })
    }
    const initialValues = {
        first_name: '',
        last_name: '',
        email: '',
        "location": ''
    }
    const validate = values => {
        let errors = {};

        if (values.first_name === '') {
            errors.first_name = "Please enter first name"
        }
        if (values.last_name === '') {
            errors.last_name = "Please enter last name"
        }
        if (values.email === '') {
            errors.email = "Please provide a valid Email Address"
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'Please provide a valid Email Address';
        }

        return errors;
    }
    const formik = useFormik({
        initialValues,
        onSubmit,
        validate,
    });

    useEffect(() => {
        let isMounted = true;
        setTimeout(() => {
            if (isMounted) {
                seterrorsOut(props.errors)
            }
        });
        return () => {
            isMounted = false;
          }
    }, [props.errors])

    useEffect(() => {
        props.setSubmitSuccess(true)
    }, [props])

    useEffect(() => {
        if (openSnackbar === true) {
            setTimeout(() => {
                setOpenSnackbar(false)
            }, 2000)
        }
    }, [openSnackbar])

    useEffect(() => {
        let isMounted = true;
        fetch(`${config.baseUrl}get-property-type/`,
            {
                headers: {
                    "Authorization": `${process.env.REACT_APP_API_KEY}`,
                    'Accept-Encoding': 'gzip, deflate',
                }
            })
            .then(async response => {
                const result = await response.json()
                if (response.status === 201 || response.status === 200) {
                    if (isMounted) {
                        setItemstype(result)
                    }
                }
                else if (response.status === 403) {
                    localStorage.setItem('access_token', '')
                }
            }
            )
            .catch((error) => {
                console.error('error message', error)
            })
        return () => {
            isMounted = false;
        }
    }, [])

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function Contactus() {
        return (
            <>
                <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5">
                            <div className="justify-content-md-between align-items-md-center">
                                <h3 className="headerfont">Contact Us</h3>
                                <div className="contentfonthead">To speak with a Calque representative, call</div>
                                <div className="contentfont">
                                    <a className="tel" href={`tel:${props?.contactGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.contactGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Or send an email to</div>
                                <div className="contentfont">
                                    <a className="mailto" href={`mailto:${props?.emailGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.emailGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Our address is</div>
                                <div className="contentfont">
                                    <b>
                                        <p className="contactAddress">
                                            {props?.addressGlobal?.application_config_value}
                                        </p>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    function calqueMarket() {
        return (
            <>
                <form onSubmit={formik.handleSubmit} noValidate>
                    <div className="container d-none d-md-block">
                        <div className="row">
                            <div className="col-6 p-5">
                                <h2 className="jost-bold">WE'RE WORKING ON IT!</h2>
                                <p className="pt-4">Thanks for your interest in The Trade-In Mortgage™!Calque is not currently operating in your market, but
                                    we’re expanding fast.</p>
                                <p>If you give us your name and email, we will reach out once we arrive.</p>
                            </div>
                            <div className="col-6">
                                <div className="col-12 top-padding-small py-3">
                                    <h6>Name</h6>
                                    <div className="row">
                                        <div className="col-6">
                                            <TextField
                                                className="w-100"
                                                placeholder="First Name"
                                                type="text"
                                                name="first_name"
                                                onChange={formik.handleChange}
                                                value={formik.values.first_name}
                                                variant="outlined"
                                            />
                                            {validateUserInfo === true ? formik.errors.first_name ?
                                                <div className="error-msg">{formik.errors.first_name}</div> : ''
                                                : ''}
                                        </div>
                                        <div className="col-6">
                                            <TextField
                                                className="w-100"
                                                placeholder="Last Name"
                                                name="last_name"
                                                type="text"
                                                onChange={formik.handleChange}
                                                value={formik.values.last_name}
                                                variant="outlined"
                                            />
                                            {validateUserInfo === true ? formik.errors.last_name ?
                                                <div className="error-msg">{formik.errors.last_name}</div> : ''
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 py-3">
                                    <h6>Email Address</h6>
                                    <div className="row">
                                        <div className="col-12">
                                            <TextField
                                                placeholder="Email"
                                                variant="outlined"
                                                name="email"
                                                type="text"
                                                onChange={formik.handleChange}
                                                value={formik.values.email}
                                                className="w-100"
                                            />
                                            {validateUserInfo === true ? formik.errors.email ?
                                                <div className="error-msg">{formik.errors.email}</div> : ''
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 py-3">
                                    <div className="row">
                                        <div className="col-12">
                                            <Button
                                                disableelevation="true"
                                                type="submit"
                                                variant="contained"
                                                color="inherit"
                                                className="w-100"
                                                style={{ height: '50px', backgroundColor: '#FBC04E' }}
                                                onClick={(e) => { GAEventTracker("Submit Now(Non Operating Area)"); handlePopupSubmit(e) }}
                                            >
                                                Submit Now
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container d-block d-md-none">
                        <div>
                            <div className="p-2">
                                <h2 className="jost-bold">WE'RE WORKING ON IT!</h2>
                                <p className="pt-4">Thanks for your interest in The Trade-In Mortgage™!Calque is not currently operating in your market, but
                                    we’re expanding fast.</p>
                                <p>If you give us your name and email, we will reach out once we arrive.</p>
                            </div>
                            <div>
                                <div className="top-padding-small py-3">
                                    <h6>Name</h6>
                                    <div>
                                        <div>
                                            <TextField
                                                className="w-100"
                                                placeholder="First Name"
                                                type="text"
                                                name="first_name"
                                                onChange={formik.handleChange}
                                                value={formik.values.first_name}
                                                variant="outlined"
                                            />
                                            {validateUserInfo === true ? formik.errors.first_name ?
                                                <div className="error-msg">{formik.errors.first_name}</div> : ''
                                                : ''}
                                        </div>
                                    </div>
                                    <div className="pt-3">
                                        <div>
                                            <TextField
                                                className="w-100"
                                                placeholder="Last Name"
                                                name="last_name"
                                                type="text"
                                                onChange={formik.handleChange}
                                                value={formik.values.last_name}
                                                variant="outlined"
                                            />
                                            {validateUserInfo === true ? formik.errors.last_name ?
                                                <div className="error-msg">{formik.errors.last_name}</div> : ''
                                                : ''}
                                        </div>

                                    </div>
                                </div>
                                <div className="py-3">
                                    <h6>Email Address</h6>
                                    <div>
                                        <div>
                                            <TextField
                                                placeholder="Email"
                                                variant="outlined"
                                                name="email"
                                                type="text"
                                                onChange={formik.handleChange}
                                                value={formik.values.email}
                                                className="w-100"
                                            />
                                            {validateUserInfo === true ? formik.errors.email ?
                                                <div className="error-msg">{formik.errors.email}</div> : ''
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="py-3">
                                    <div>
                                        <Button
                                            disableelevation="true"
                                            type="submit"
                                            variant="contained"
                                            color="inherit"
                                            className="w-100"
                                            style={{ height: '50px', backgroundColor: '#FBC04E' }}
                                            onClick={(e) => { GAEventTracker("Submit Now(Non Operating Area)"); handlePopupSubmit(e) }}
                                        >
                                            Submit Now
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </>
        )
    }

    return (
        <div>
            <div className="col-12">
                <div className="row">
                    <div className="col-md-7 p-0 d-sm-none  d-none d-md-block">
                        <div className="banner-img-md" style={{position:"relative"}}>
                            {
                                props?.partner?.url_path === 'susser' ? (
                                    <img src="/assets/images/home_compressed.webp" style={{ filter: 'grayscale(100%)' }} className="Home Image" alt="Home" />
                                ) 
                                // :  props?.partner?.url_path === 'c2' ?
                                // (
                                //     <>
                                //         <h5 style={{position:"absolute",left:"18%",top:"13%",fontWeight:"600"}}>Tap your equity to buy and move before you sell.</h5>
                                //         <img src="/assets/images/home_compressed.webp" className="Home Image" alt="Home" />
                                //     </>
                                // )
                                :
                                (
                                    <img src="/assets/images/home_compressed.webp" className="Home Image" alt="Home" />
                                )
                            }
                        </div>
                    </div>
                    <div className="col-md-7 p-0 d-sm-block  d-block d-md-none">
                        <div className="banner-img-sm" style={{position:"relative"}}>
                            {
                                props?.partner?.url_path === 'susser' ? (
                                    <img src="/assets/images/home_compressed.webp" style={{ filter: 'grayscale(100%)' }} className="Home Image" alt="Home" />
                                )
                                //  :  props?.partner?.url_path === 'c2' ?
                                // (
                                //     <>
                                //         <h5 style={{position:"absolute",left:"4%",top:"11%",fontWeight:"600"}}>Tap your equity to buy and move before you sell.</h5>
                                //         <img src="/assets/images/home_compressed.webp" className="Home Image" alt="Home" />
                                //     </>
                                // )
                                :
                                (

                                    <img src="/assets/images/home_compressed.webp" className="Home Image" alt="Home" />
                                )
                            }
                        </div>
                    </div>
                    <div className="col-md-5 primary-background text-white" style={{ height: '600px', backgroundColor: `${props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
                        <div className="d-flex justify-content-center align-items-center w-100 h-100">
                            <div className="p-lg-5 p-md-2 px-sm-3 py-sm-4 px-2 py-4">
                                <div className="col-12 p-2">
                                    {props?.partner?.url_path === 'megastar' ? <h2 className="jost-bold">7-Day Non-Contingent Buyer Program</h2> :props?.partner?.url_path === 'c2' ? <h2 className="jost-bold">C2 Buy Before You Sell</h2>:<h2 className="jost-bold">The Trade-In Mortgage<span style={{ fontSize: '2rem' }}>™</span></h2>}
                                    {/* {props?.partner?.url_path === 'c2' ?
                                    <p className="">
                                        Tap your equity to buy and move before you sell.
                                    </p>:""} */}
                                    <p className="">
                                    {props?.partner?.url_path === 'megastar' ? 'Qualify and buy as if your house has already sold.' : props?.partner?.url_path === 'c2' || props?.partner?.url_path === 'rapid' || props?.partner?.url_path === 'oxford' || props?.partner?.url_path === 'usmortgage' || props?.partner?.url_path === 'homesouth' || props?.partner?.url_path === 'rivercity' || props?.partner?.url_path === 'fenero' || props?.partner?.url_path === 'james' || props?.partner?.url_path === 'interconnect' || props?.partner?.url_path === 'patelco' || props?.partner?.url_path === 'platte' || props?.partner?.url_path === 'newcastle' || props?.partner?.url_path === 'mustache' || props?.partner?.url_path === 'bayshore' || props?.partner?.url_path === 'clearpath' || props?.partner?.url_path === 'mortgagetrust' || props?.partner?.url_path === 'midflorida' || props?.partner?.url_path === 'sparrow' || props?.partner?.url_path === 'apex' || props?.partner?.url_path === 'alcova' || props?.partner?.url_path === 'matador' || props?.partner?.url_path === 'harboronemortgage' || props?.partner?.url_path === 'financialdwellings' || props?.partner?.url_path === 'ruoff' || props?.partner?.url_path === 'nest' || props?.partner?.url_path === 'advisorsmortgage' || props?.partner?.url_path === 'sifi' || props?.partner?.url_path === 'southeastmortgage' || props?.partner?.url_path === 'novus' ? ' Tap your equity to buy and move before you sell.':'Use the equity in your current home to buy and move into your next home before you sell.'}
                                    </p>
                                </div>
                                {/* <div className="col-12 p-1 px-2 jost-medium">
                                    <GoogleMaps handleChange={props.handleChange} {...props} handleLocation={props.handleLocation} values={props.values} setFieldValue={props.setFieldValue} setAddress={setAddress} address={address} errors={props.errors} validateDisplay17={props.validateDisplay17} validateDisplay18={props.validateDisplay18} errorsOut={errorsOut} validateControl={props.validateControl} setSubmitSuccess={props.setSubmitSuccess} submitSuccess={props.submitSuccess} setDisplayError={props.setDisplayError} displayError={props.displayError} gmapErr={gmapErr} />
                                </div>
                                <div className="col-12 p-0 jost-medium" >
                                    <FormControl variant="outlined" className="property-select w-100 px-2 py-1">
                                        <select
                                            name="property_type_id"
                                            onChange={(e) => { props.handleChange(e) }}
                                            value={props.values.property_type_id ? props.values.property_type_id : 'Property Type'}
                                            displayempty="true"
                                            style={props?.partner?.url_path === "c2" ?{ height: '54px', backgroundColor: '#fff', color: '#000', fontFamily:"FTPolar-Light" }:{ height: '54px', backgroundColor: '#fff', color: '#000' }}
                                            inputprops={{ 'aria-label': 'Without label' }}
                                            required
                                            IconComponent={() => (
                                                <ExpandMoreIcon />
                                            )}
                                        >
                                            <option values="" disabled>Property Type</option>
                                            {itemstype.map((item) => (
                                                <option key={item.property_type_id} value={item.property_type_id}>
                                                    {item.property_type}
                                                </option>
                                            ))}
                                        </select>
                                        {errorsOut && props.validateControl === true && props.errDisplay === false ? errorsOut.property_type_id && errorsOut.property_type_id ?
                                            <div className={props?.partner?.url_path === "flagstar" ? "error-msg-flagstar pt-1" : "error-msg pt-1"}>{errorsOut.property_type_id}</div> : ''
                                            : ''}
                                    </FormControl>
                                </div> */}
                                <div className="col-12 p-1 px-2">
                                  <ApplicationFunnel/>
                                </div>
                                <div className="col-12 p-0">
                                    <div className="px-2 py-3 w-100">
                                        {/* <Button
                                            variant="contained" disableelevation="true"
                                            color="inherit"
                                            type={props.submitSuccess === true ? "submit" : "button"}
                                            className="w-100 jost-bold"
                                            style={{ height: '54px', color: 'white', backgroundColor: `${props.partner.secondary_color ? props.partner.secondary_color : '#2A83C2'}` }}
                                            onClick={(e) => { GAEventTrackerGetStarted("Get started", 1); handleZipCode() }}
                                            {...{
                                                "aria-haspopup": "true",
                                            }}
                                        >
                                            {props?.partner?.url_path === "hma"?"Get Your Calque Backup Offer":"Get started"}
                                        </Button> */}
                                        <p className="text-center py-3 m-0" style={props?.partner?.url_path === "hma"?{ fontSize: '16px' }:{ fontSize: '14px' }}>{props?.partner?.url_path === "hma"?'To find out if this program is right for you, reach out to your loan officer or find one in': (props?.partner?.url_path === "emm" || props?.partner?.url_path === "ideal" || props?.partner?.url_path === "maximus" || props?.partner?.url_path === "fidelity")?"To find out if this program is right for you, reach out to your loan officer or find one in our":"*It's free and only takes 5 minutes! If you prefer to set up a phone call to talk to one of Calque's associates, please"}&nbsp;
                                            {props?.partner?.url_path === "hma"?
                                            <a href='https://www.hmamortgage.com/team/' style={{color:"#fff",textDecoration:"underline"}}>our directory.</a>
                                            : props?.partner?.url_path === "emm"?
                                            <a href='https://www.emmloans.com/branches/' style={{color:"#fff",textDecoration:"underline"}}>directory.</a>
                                            : props?.partner?.url_path === "ideal"?
                                            <a href='https://www.imlending.com/about-us/meet-our-professionals' style={{color:"#fff",textDecoration:"underline"}}>directory.</a>
                                            : props?.partner?.url_path === "maximus"?
                                            <a href='https://maxloans.com/team-maximus/' style={{color:"#fff",textDecoration:"underline"}}>directory.</a>
                                            : props?.partner?.url_path === "fidelity"?
                                            <a href='https://www.fidelitylending.com/team' style={{color:"#fff",textDecoration:"underline"}}>directory.</a>
                                            :
                                            <Link activeclass="active"
                                                to="contact"
                                                spy={true}
                                                smooth="true"
                                                offset={-70}
                                                duration={500}
                                                style={{ textDecoration: 'underline' }}
                                                onClick={(e) => { GAEventTrackerContactUs("Contact Us", 1); handleClickOpen2() }}>
                                                click here.
                                            </Link>}
                                        </p>
                                        {/* {props?.partner?.url_path === "alcova" && <Chatbot/>} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-sm-none d-none d-md-none d-lg-block" style={{ height: '30vh', backgroundColor: '#fff' }}>
                <div className="banner-subinfo position-absolute">
                    <div className="banner-subinfo-content col-12" style={props?.partner?.url_path === 'apex' ? {backgroundColor:'#D4AA56'} :{ backgroundColor: `${props.partner.tertiary_color}` ? `${props.partner.tertiary_color}` : '#8E97A7' }} >
                        <div className="d-flex justify-content-around align-items-top p-2">
                            <div className="px-4 text-center text-box" style={props?.partner?.url_path === "apex"?{color:"#000"}:{}}>
                                <h4 className="montserrat-bold" >More Convenience</h4>
                                <p className="p-2 m-0">Buy your dream home now and sell your current home when you’re ready. </p>
                            </div>
                            <div className="separator" style={props?.partner?.url_path === "apex"?{borderColor:"#000"}:{}}></div>
                            <div className="px-4 text-center text-box" style={props?.partner?.url_path === "apex"?{color:"#000"}:{}}>
                                <h4 className="montserrat-bold">{props?.partner?.url_path === 'c2' || props?.partner?.url_path === 'fairway' || props?.partner?.url_path === 'homesouth' || props?.partner?.url_path === 'rivercity' || props?.partner?.url_path === 'searchlight' || props?.partner?.url_path === 'oxford' || props?.partner?.url_path === 'usmortgage' || props?.partner?.url_path === 'rapid' || props?.partner?.url_path === 'ideal' || props?.partner?.url_path === 'maximus' || props?.partner?.url_path === 'fidelity' || props?.partner?.url_path === 'emm' || props?.partner?.url_path === 'fenero' || props?.partner?.url_path === 'james' || props?.partner?.url_path === 'interconnect' || props?.partner?.url_path === 'platte'|| props?.partner?.url_path === 'bayshore' || props?.partner?.url_path === 'newcastle' || props?.partner?.url_path === 'mustache' || props?.partner?.url_path === 'apex' || props?.partner?.url_path === 'alcova' ? "More Winning" : props?.partner?.url_path === 'patelco' ? "Better Offers" : 'More Confidence'}</h4>
                                <p className="p-2 m-0">{props?.partner?.url_path === 'megastar' ? 'Submit a 7-day non-contingent offer as good as cash to win.' : props?.partner?.url_path === 'patelco' ? "Submit non-contingent offers as good as cash." : 'Submit non-contingent offers as good as cash and win.'} </p>
                            </div>
                            <div className="separator" style={props?.partner?.url_path === "apex"?{borderColor:"#000"}:{}}></div>
                            <div className="px-4 text-center text-box" style={props?.partner?.url_path === "apex"?{color:"#000"}:{}}>
                                <h4 className="montserrat-bold">{props?.partner?.url_path === 'c2' || props?.partner?.url_path === 'fairway' || props?.partner?.url_path === 'homesouth' || props?.partner?.url_path === 'rivercity' || props?.partner?.url_path === 'searchlight' || props?.partner?.url_path === 'oxford' || props?.partner?.url_path === 'usmortgage' || props?.partner?.url_path === 'rapid' || props?.partner?.url_path === 'ideal' || props?.partner?.url_path === 'maximus' || props?.partner?.url_path === 'fidelity' || props?.partner?.url_path === 'emm' || props?.partner?.url_path === 'fenero' || props?.partner?.url_path === 'james' || props?.partner?.url_path === 'interconnect' || props?.partner?.url_path === 'patelco' || props?.partner?.url_path === 'platte' || props?.partner?.url_path === 'bayshore' || props?.partner?.url_path === 'newcastle' || props?.partner?.url_path === 'mustache' || props?.partner?.url_path === 'apex' || props?.partner?.url_path === 'alcova' ?"More Confidence":'More Freedom'}</h4>
                                <p className="p-2 m-0">{props?.partner?.url_path === 'c2' || props?.partner?.url_path === 'apex' || props?.partner?.url_path === 'alcova' ?"Eliminate stress with a guaranteed backup offer from Calque." : (props?.partner?.url_path === 'fairway' || props?.partner?.url_path === 'homesouth'|| props?.partner?.url_path === 'rivercity' || props?.partner?.url_path === 'searchlight' || props?.partner?.url_path === 'oxford' || props?.partner?.url_path === 'usmortgage' || props?.partner?.url_path === 'rapid' || props?.partner?.url_path === 'ideal' || props?.partner?.url_path === 'maximus' || props?.partner?.url_path === 'fidelity' || props?.partner?.url_path === 'emm' || props?.partner?.url_path === 'fenero' || props?.partner?.url_path === 'james' || props?.partner?.url_path === 'interconnect' || props?.partner?.url_path === 'patelco' || props?.partner?.url_path === 'platte' || props?.partner?.url_path === 'bayshore' || props?.partner?.url_path === 'newcastle' || props?.partner?.url_path === 'mustache') ? "Stress less with a guaranteed backup offer from Calque." : "Work with the real estate agent of your choice."}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-lg-none d-md-block d-sm-block p-3" style={{ backgroundColor: '#fff' }}>
                <div className="banner-subinfo-content col-12" style={props?.partner?.url_path === 'apex' ? {backgroundColor:'#D4AA56'} :{ backgroundColor: `${props.partner.tertiary_color}` ? `${props.partner.tertiary_color}` : '#8E97A7' }}>
                    <div className="row">
                        <div className="col-12 px-3 py-4 text-center" style={props?.partner?.url_path === "apex"?{color:"#000"}:{}}>
                            <h4 className="montserrat-bold">More Convenience</h4>
                            <p className="p-2 m-0">Buy your dream home now and sell your current home when you’re ready. </p>
                        </div>
                        <div className="col-12 px-3 py-4 text-center" style={props?.partner?.url_path === "apex"?{color:"#000"}:{}}>
                            <h4 className="montserrat-bold">{props?.partner?.url_path === 'c2'|| props?.partner?.url_path === 'homesouth' || props?.partner?.url_path === 'rivercity' || props?.partner?.url_path === 'searchlight' || props?.partner?.url_path === 'oxford' || props?.partner?.url_path === 'usmortgage' || props?.partner?.url_path === 'rapid' || props?.partner?.url_path === 'ideal' || props?.partner?.url_path === 'maximus' || props?.partner?.url_path === 'fidelity' || props?.partner?.url_path === 'emm' || props?.partner?.url_path === 'fenero' || props?.partner?.url_path === 'james' || props?.partner?.url_path === 'interconnect' || props?.partner?.url_path === 'platte' || props?.partner?.url_path === 'bayshore' || props?.partner?.url_path === 'newcastle' || props?.partner?.url_path === 'mustache' || props?.partner?.url_path === 'apex' || props?.partner?.url_path === 'alcova' ? "More Winning" : props?.partner?.url_path === 'patelco' ? "Better Offers" : 'More Confidence'}</h4>
                            <p className="p-2 m-0">{props?.partner?.url_path === 'megastar' ? 'Submit a 7-day non-contingent offer as good as cash to win.' : props?.partner?.url_path === 'patelco' ? "Submit non-contingent offers as good as cash." : 'Submit non-contingent offers as good as cash and win.'} </p>
                        </div>
                        <div className="col-12 px-3 py-4 text-center" style={props?.partner?.url_path === "apex"?{color:"#000"}:{}}>
                            <h4 className="montserrat-bold">{props?.partner?.url_path === 'c2' || props?.partner?.url_path === 'homesouth' || props?.partner?.url_path === 'rivercity' || props?.partner?.url_path === 'searchlight' || props?.partner?.url_path === 'oxford' || props?.partner?.url_path === 'usmortgage' || props?.partner?.url_path === 'rapid' || props?.partner?.url_path === 'ideal' || props?.partner?.url_path === 'maximus' || props?.partner?.url_path === 'fidelity' || props?.partner?.url_path === 'emm' || props?.partner?.url_path === 'fenero' || props?.partner?.url_path === 'james' || props?.partner?.url_path === 'interconnect' || props?.partner?.url_path === 'patelco' || props?.partner?.url_path === 'platte' || props?.partner?.url_path === 'bayshore' || props?.partner?.url_path === 'newcastle' || props?.partner?.url_path === 'mustache' || props?.partner?.url_path === 'apex' || props?.partner?.url_path === 'alcova' ? "More Confidence":'More Freedom'}</h4>
                            <p className="p-2 m-0">{props?.partner?.url_path === 'c2' || props?.partner?.url_path === 'homesouth' || props?.partner?.url_path === 'rivercity' || props?.partner?.url_path === 'searchlight' || props?.partner?.url_path === 'oxford' || props?.partner?.url_path === 'usmortgage' || props?.partner?.url_path === 'rapid' || props?.partner?.url_path === 'ideal' || props?.partner?.url_path === 'maximus' || props?.partner?.url_path === 'fidelity' || props?.partner?.url_path === 'emm' || props?.partner?.url_path === 'fenero' || props?.partner?.url_path === 'james' || props?.partner?.url_path === 'interconnect' || props?.partner?.url_path === 'patelco' || props?.partner?.url_path === 'platte' || props?.partner?.url_path === 'bayshore' || props?.partner?.url_path === 'newcastle' || props?.partner?.url_path === 'mustache' ? "Stress less with a guaranteed backup offer from Calque.": (props?.partner?.url_path === 'apex' || props?.partner?.url_path === 'alcova') ? 'Eliminate stress with a guaranteed backup offer from Calque.' : props.pathname.partner_name !== 'Susser' ? "Work with the real estate agent of your choice." :props.pathname.partner_name !== 'Susser' ? "Work with the real estate agent of your choice." : props.pathname.partner_name !== 'Susser' ? "Work with the real estate agent of your choice." : "Work with the real estate agent of your choice."}</p>
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleClose1}
                anchorOrigin={{ vertical, horizontal }} >
                <Alert onClose={handleClose1} severity={severity_type}>
                    <div className="error" style={{ color: 'white' }}>
                        <span>{detail}</span>
                    </div>
                </Alert>
            </Snackbar>
            <Modalpopup open={openSubmit} handleClickOpen={handleClickOpen2} contact={Contactus()} />
            <Modalpopupcalquemarket open={openCalque} handleClickOpener={handleClickOpener} contactData={calqueMarket()} />
            {props.cdrawerHome === false &&
                <CustomDrawer cdrawer={props.cdrawer} loader={props.loader} handleProgress={props.handleProgress} formik={props.formik} {...props} handleNext={props.handleNext} handleChange={props.handleChange} values={props.values} getEstimateButton={props.getEstimateButton} ValidateFinalError={props.ValidateFinalError} gaUserNotAnswered={props.gaUserNotAnswered} setGaUserNotAnswered={props.setGaUserNotAnswered} GAtimerFinish={props.GAtimerFinish}  setCaptchaValue={props.setCaptchaValue} captchaValue={props.captchaValue} validateDisplay10={props.validateDisplay10}/>
            }
        </div>
    )
}
